import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UiService } from '../services/ui.service';

export const featureFlagGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const uiService = inject(UiService);

  const requiredFeature = route.data?.['requiredFeature'] as string | undefined;

  // Si no se requiere ninguna feature, dejamos pasar por defecto
  if (!requiredFeature) {
    return true;
  }

  // Validar si el usuario tiene la feature activa
  if (authService.hasFeature(requiredFeature)) {
    return true;
  }

  // No tiene permiso: redirigir y mostrar error
  uiService.showError('Tu organización no tiene contratado este módulo.');
  return router.createUrlTree(['/admin/dashboard']);
};
